import { render } from "./TransactionHeader.vue?vue&type=template&id=1c7d6478&ts=true"
import script from "./TransactionHeader.vue?vue&type=script&lang=ts"
export * from "./TransactionHeader.vue?vue&type=script&lang=ts"

import "./TransactionHeader.vue?vue&type=style&index=0&id=1c7d6478&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__